<div class="product-services-form-container">
  <div class="order-form-header">
    <h2 class="form-title">{{ "Create New Order" | translator }}</h2>
    <p class="form-subtitle">{{ "Fill in the details below to create a new order" | translator }}</p>
  </div>

  <form [formGroup]="orderForm" (ngSubmit)="onSubmit()" class="product-services-form">
    
    <!-- Customer Information Section -->
    <div class="form-section">
      <h3 class="section-title">
        <i class="pi pi-user"></i>
        {{ "Customer Information" | translator }}
      </h3>
      
      <div formGroupName="customer">
        <div class="form-row">
          <div class="form-group">
            <label for="customerName" class="form-label">
              {{ "Customer Name" | translator }} <span class="required">*</span>
            </label>
            <input type="text" id="customerName" formControlName="name" class="input-ui"
                   [class.is-invalid]="isFieldInvalid('customer.name')"
                   placeholder="{{ 'Enter customer name' | translator }}" />
            <div *ngIf="isFieldInvalid('customer.name')" class="invalid-feedback">
              {{ getFieldError('customer.name') }}
            </div>
          </div>
          
          <div class="form-group">
            <label for="customerEmail" class="form-label">
              {{ "Email Address" | translator }} <span class="required">*</span>
            </label>
            <input type="email" id="customerEmail" formControlName="email" class="input-ui"
                   [class.is-invalid]="isFieldInvalid('customer.email')"
                   placeholder="{{ 'Enter email address' | translator }}" />
            <div *ngIf="isFieldInvalid('customer.email')" class="invalid-feedback">
              {{ getFieldError('customer.email') }}
            </div>
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-group">
            <label for="customerPhone" class="form-label">
              {{ "Phone Number" | translator }}
            </label>
            <input type="tel" id="customerPhone" formControlName="phone" class="input-ui"
                   placeholder="{{ 'Enter phone number' | translator }}" />
          </div>
          
          <div class="form-group">
            <label for="customerOrganization" class="form-label">
              {{ "Organization" | translator }}
            </label>
            <input type="text" id="customerOrganization" formControlName="organization" class="input-ui"
                   placeholder="{{ 'Enter organization name' | translator }}" />
          </div>
        </div>
      </div>
    </div>

    <!-- Product Details Section -->
    <div class="form-section">
      <h3 class="section-title">
        <i class="pi pi-info-circle"></i>
        {{ "Service Details" | translator }}
      </h3>
      
      <div class="service-card-summary">
        <!-- Service Title -->
        <div class="service-title">
          <h3>{{ productService?.name || 'N/A' }}</h3>
        </div>

        <!-- Service Price -->
        <div class="service-price" *ngIf="productService?.pricing">
          <span class="price-amount" *ngIf="isNumericPrice(productService.pricing.amount)">{{ formatPriceDisplay(productService.pricing.amount) }}</span>
          <span class="price-amount price-text" *ngIf="!isNumericPrice(productService.pricing.amount)">{{ productService.pricing.amount }}</span>
          <img *ngIf="isNumericPrice(productService.pricing.amount)" 
               src="assets/pdf/graphics/Saudi_Riyal_Symbol-1.png" 
               alt="SAR" 
               class="price-currency-icon w-12px" />
          <span class="price-vat" *ngIf="isNumericPrice(productService.pricing.amount) && productService.pricing.includesVAT">*{{'including VAT' | translator}}</span>
        </div>

        <!-- Service Type Badge -->
        <div class="service-type-badge" *ngIf="getServiceType()">
          <span class="type-tag">{{ getServiceType() }}</span>
        </div>

        <!-- Service Status -->
        <div class="service-status">
          <span class="status-badge" [class.status-active]="productService?.status === 'ACTIVE'" 
                [class.status-draft]="productService?.status === 'DRAFT'">
            {{ productService?.status || 'N/A' }}
          </span>
        </div>

        <!-- Divider Line -->
        <hr class="service-divider">

        <!-- Service Description -->
        <div class="service-description" *ngIf="getServiceField('Service Description')">
          <h4 class="section-heading">{{ "Service Description" | translator }}</h4>
          <p>{{ getServiceField('Service Description') }}</p>
        </div>

        <!-- Service Conditions -->
        <div class="service-conditions" *ngIf="getServiceField('Service Conditions and Requirements')">
          <h4 class="section-heading">{{ "Conditions and Requirements" | translator }}</h4>
          <p>{{ getServiceField('Service Conditions and Requirements') }}</p>
        </div>

        <!-- Target Audience -->
        <div class="service-audience" *ngIf="getServiceField('Target Audience')">
          <h4 class="section-heading">{{ "Target Audience" | translator }}</h4>
          <p>{{ getServiceField('Target Audience') }}</p>
        </div>

        <!-- Service Fees -->
        <div class="service-fees" *ngIf="getServiceField('Service Fees')">
          <h4 class="section-heading">{{ "Service Fees" | translator }}</h4>
          <p>{{ getServiceField('Service Fees') }}</p>
        </div>
      </div>
    </div>

    <!-- Survey Field -->
    <div class="form-section" *ngIf="getServiceField('Survey Link')">
      <h3 class="section-title">
        <i class="pi pi-question-circle"></i>
        {{ "Survey Information" | translator }}
      </h3>
      
      <p> {{ "Please Fill out the survey before placing an order" | translator }} </p>

      <button *ngIf="!validSurvey" type="button" class="btn btn-info mb-3" (click)="openSurveyLink()">
        <i class="pi pi-external-link"></i>
        {{ "Open Survey" | translator }}
      </button>

      <div *ngIf="validSurvey">
        <!-- <app-popupview-questions [(currentQuestion)]="survey.questions"></app-popupview-questions> -->

        <!-- <div class="service-card-summary"> -->
      <ng-container *ngFor="let question of survey.questions">
          <app-question-template-standalone *ngIf="canShowCondQuestion(question)" 
              [question]="question" 
              [isRequired]="isQuestionRequired(question)"
              [isRequiredColor]="isQuestionInvalid(question)">
          </app-question-template-standalone>
        </ng-container>
      <!-- </div> -->

      </div>
            
      
    </div>

    <!-- Form Actions -->
    <div class="form-actions">
      <button type="button" class="btn btn-secondary" (click)="onCancel()" [disabled]="isSubmitting">
        <i class="pi pi-times"></i>
        {{ "Cancel" | translator }}
      </button>
      <button 
              type="submit" 
              class="btn btn-primary" 
              (click)="markSubmitAttempted()"
              [disabled]="!orderForm.valid || isSubmitting">
        <i class="pi pi-check" *ngIf="!isSubmitting"></i>
        <i class="pi pi-spinner pi-spin" *ngIf="isSubmitting"></i>
        {{ isSubmitting ? ('Creating Order...' | translator) : ('Create Order' | translator) }}
      </button>
    </div>
  </form>
</div>
